import { toast } from 'react-toastify';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import CustomToast from '../../Component/CustomToast/CustomToast';

export const handleThankYouSubmit = ({ address , error , checked , setUrlPayload }) => {

    if (error !== '') {
        toast(<CustomToast message={error} state={'error'} />);
        return;
    }

    const uniqueId = uuidv4();

    const payload = [
        {
            id: uniqueId,
            redirectUri: address,
            redirectHttpPost: !checked
        }
    ];

    if (payload[0].redirectUri === '') {
        toast(<CustomToast message={'لطفا آدرس اینترنتی را وارد کنید'} state={'error'} />);
        return;
    }

    setUrlPayload(payload);
    toast(<CustomToast message={'آدرس اینترنتی با موفقیت ذخیره شد'} state={'success'} />);

    axios.post('/your-content-upload-endpoint', payload)
        .then(response => {
            // console.log('Content successfully uploaded:', response.data);
        })
        .catch(error => {
            // console.error('Error uploading content:', error);
        });
};
